import { render, staticRenderFns } from "./MobilePushMenuItem.vue?vue&type=template&id=51208bf6&scoped=true"
import script from "./MobilePushMenuItem.vue?vue&type=script&lang=js"
export * from "./MobilePushMenuItem.vue?vue&type=script&lang=js"
import style0 from "./MobilePushMenuItem.vue?vue&type=style&index=0&id=51208bf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51208bf6",
  null
  
)

export default component.exports